import { useFeatureFlagEnabled } from "@posthog/react";
import { PRO_CRM_COPILOT_FLAG_KEY } from "../lib/feature-flags";

/**
 * Resolves whether the Pro CRM Copilot (dock + header pill + `/assistant`
 * page) is enabled for the current pro.
 *
 * Fail-closed in prod: `useFeatureFlagEnabled` returns `true | false |
 * undefined`, and only an explicit `true` unlocks the copilot — an absent /
 * still-loading / disabled flag keeps every copilot surface hidden, so a
 * controlled PostHog rollout governs exposure (and the flag doubles as a
 * kill-switch). `import.meta.env.DEV` is OR-ed in so local dev + preview
 * builds — which usually have no PostHog project wired and would otherwise see
 * `undefined` — keep the copilot fully usable without a flag.
 */
export function useCopilotEnabled(): boolean {
  const flag = useFeatureFlagEnabled(PRO_CRM_COPILOT_FLAG_KEY);
  return import.meta.env.DEV || flag === true;
}
